const formatMessage = (level, msg, meta) => {
    const metaStr = Object.keys(meta).length ? JSON.stringify(meta, null, 2) : '';
    return `[${level}]: ${msg} ${metaStr}`;
};

export const log = {
    error: (msg, meta = {}) => console.error(formatMessage('ERROR', msg, meta), meta),
    warn:  (msg, meta = {}) => console.warn(formatMessage('WARN', msg, meta), meta),
    info:  (msg, meta = {}) => console.info(formatMessage('INFO', msg, meta), meta),
    debug: (msg, meta = {}) => console.debug(formatMessage('DEBUG', msg, meta), meta),
};

export default log;